import React, { Component } from "react";
import "./footer.css";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMobileAlt } from "@fortawesome/free-solid-svg-icons";

class Footer extends Component {
  render() {
    return (
      <footer className="footer">
        <div className="footer-content row ml-1">
          <div className="col-md-3 footer-about">
            <div>
              <h3>Consulta ZAP</h3>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua.
              </p>
            </div>
          </div>
          <div className="col-md-3 footer-menu">
            <ul className="footer-list-options">
              <li>
                <Link to={"/signup"}>Seja um especialista</Link>
              </li>
              <li>
                <Link to={"/como-funciona"}>Como funciona</Link>
              </li>
              <li>
                <Link to={"/categorias"}>Especialidades</Link>
              </li>
              <li>
                <Link to={"/fale-conosco"}>Fale conosco</Link>
              </li>
              <li>
                <Link to={"/faq"}>Perguntas frequentes</Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="text-center copyright-container">
          <h3 id="textoEndereco">
            {" "}
            Copyright @ 2020 Consulta ZAP | Todos os direitos reservados{" "}
          </h3>
          <br />
          <h3 id="textoEndereco"> CNPJ n. 000.000.000/0000-00 / Endereço </h3>
        </div>
      </footer>
    );
  }
}

export default Footer;
